<kv-editor-container [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups"
    [inputComponent]="inputComponent" [status]="pageStatus" [canSave]="canSave$ | async"></kv-editor-container>